// -*- Mode: rjsx -*-
import { Request } from './views/Request.jsx';
export default Request;

import RequestBreadcrumbs from './views/RequestBreadcrumbs.jsx';
export { RequestBreadcrumbs }

import PhoneClient from './views/PhoneClient.jsx';
export { PhoneClient }


import requestsSlice, { fetchRequest, setCurrentRequest, updateRequest } from './requestsSlice.js';

const CARD_TITLE_PROPS = {
	variant: "body2",
	color: "textSecondary"
};

export { CARD_TITLE_PROPS, requestsSlice, setCurrentRequest, fetchRequest, updateRequest  };

const EMPTY_REQUEST = { user: {}, claimed_by: {}, payment: {}, contact: {}, key: null };
export { EMPTY_REQUEST };

